import {GET_IpAddress,Get_Address} from '../constants/ActionTypes'

const INIT_STATE = {
    IpAddress: null,
    loading: false,
    Ipaddress1:null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_IpAddress:
            return {
                IpAddress: action.body,
                loading :false
            }
            case Get_Address:
            return {
                Ipadress1: action.body,
                loading :false
            }
        default:
            return state;
    }
}